@if (content && !isHidden) {
<footer class="page-footer"
        [bottomPanelArea]="'footer'">
    <div class="flex flex-middle flex-justify-center flex-column-m flex-column-s p-t-10 p-b-10 p-t-6-s p-b-6-s">
        <span class="flex-order-2-m flex-order-2-s m-t-4-m m-t-4-s col-1"
              sizeClass="'XL': h2, 'MS' : h4">{{'Rated as ‘excellent’ by our customers' | translate}}</span>
        <div class="m-l-3-x m-l-3-l logo-feefo flex-order-1-m flex-order-1-s"></div>
        @if (content.reviews_rating) {
        <rating class="flex fs-13 m-l-3-x m-l-3-l flex-order-3-m flex-order-3-s m-t-3-m m-t-3-s"
                [max]="5"
                [value]="content.reviews_rating / 20"></rating>
        }
    </div>
    <div class="center"
         [tradeClass]="'!bg-col-53 bg-col-55'">
        <div class="wrap-m wrap-s w-10 p-l-6 p-r-6 w-12-m w-12-s m-b-0 m-r-0">
            <div class="flex flex-justify-center flex-middle flex-column-m flex-column-s">
                <div class="w-5 w-12-m w-12-s ta-left"
                     [tradeClass]="'col-w'">
                    <h3 class="h2 m-t-5-x m-t-5-l m-t-4-m m-t-4-s"
                        *iCms="'newsletter_heading' of content"></h3>
                    <p class="m-t-2 m-t-3-m m-t-4-s"
                       sizeClass="'XL' : p2, 'MS' : p1"
                       *iCms="'newsletter_copy' of content"></p>
                    <newsletter-form class="w-12 m-t-5"
                                     [custom]="content.newsletter_checkbox"
                                     [isFooter]="true"
                                     *ifSize="'MS'"></newsletter-form>
                    @if (content.social_services.length) {
                    <ul
                        class="page-footer__social-links flex m-t-2 m-t-5-m m-t-5-s m-b-5-x m-b-5-l m-b-2-m m-b-2-s m-l-1-x m-l-1-l">
                        @for (service of content.social_services; track $index; let isFirst = $first) {
                        <li [ngClass]="isFirst ? 'm-l--1-x m-l--1-l' : 'm-l-4 m-l-3-m m-l-3-s'">
                            <a [attr.href]="service.link"
                               target="_blank"
                               rel="nofollow">
                                <img [image]="service.image">
                            </a>
                        </li>
                        }
                    </ul>
                    }
                </div>
                <newsletter-form class="w-7 m-l p-l-10 m-t-2 ta-left"
                                 [custom]="content.newsletter_checkbox"
                                 [isFooter]="true"
                                 *ifSize="'XL'"></newsletter-form>
            </div>
        </div>
    </div>
    <div *ifSize="'MS'"
         class="flex flex-justify-center m-t m-b">
        <ng-container *ngTemplateOutlet="royal"></ng-container>
    </div>
    <div class="b-t"
         [tradeClass]="'!bg-col-w !b-col-42 bg-col-54 b-col-43'">
        <div class="wrap-x wrap-l"
             [grid]="(client.isL || client.isX) ? 14 : 12"
             [gridRowGap]="0"
             [gridColumnGap]="0">
            <ng-container *ifSize="'XL'">
                @for (column of content.columns; track $index; let isFirst = $first; let isLast =
                $last) {
                <page-footer-column class="p-l-10 m-b-0 p-t-4 p-b-5 b-r"
                                    [tradeClass]="'!b-col-42 b-col-43'"
                                    [gridColumn]="3"
                                    [isFirst]="isFirst"
                                    [isLast]="isLast"
                                    [column]="column">
                </page-footer-column>
                }
                <div class="m-t-2 flex flex-column flex-justify-center p-l-20"
                     [gridColumn]="4">
                    <ng-container *ngTemplateOutlet="call"></ng-container>
                </div>
                <div class="m-t-2 flex flex-column flex-justify-center p-l-2"
                     [gridColumn]="2">
                    <ng-container *ngTemplateOutlet="mail"></ng-container>
                </div>
                <div class="m-t-2 flex flex-column flex-justify-center p-l-2"
                     [gridColumn]="2">
                    <ng-container *ngTemplateOutlet="royal"></ng-container>
                </div>
            </ng-container>
            <ng-container *ifSize="'MS'">
                @for (column of content.columns_mobile; track $index; let index = $index; let
                isLast = $last) {
                <div class="b-b height-100"
                     [tradeClass]="'!b-col-42 b-col-43'"
                     [ngClass]="{'b-r' : !isLast}"
                     [gridColumn]="4">
                    @switch (column.type) {
                    @case ('links') {
                    <h3 class="p-r-5 p-l-5 p-t p-b p-t-10 p-b-10 flex flex-middle flex-justify-center column-height no-wrap"
                        [tradeClass]="'!col-11 col-12'"
                        [zippyToggle]="['footer_dropdown', index]"
                        [zippyClass]="'selected-zippy'">
                        <span class="h4"
                              *iCms="'heading' of column; content: 'html'"></span>
                        <i class="fs-9 icon-chevron inline-flex col-43 _chevron"
                           [zippyName]="['footer_dropdown', index]"
                           [zippyClass]="'_open'"
                           aria-hidden="true"></i>
                    </h3>
                    }
                    @case ('multisite') {
                    <ng-container *ifTradeStore>
                        <ng-container *ifLoggedIn>
                            <div class="height-100 flex flex-justify-center flex-middle"
                                 [gridColumn]="4"
                                 [iCmsModalOpen]="multisiteModalId">
                                <multisite-label [isFooter]="true"></multisite-label>
                                <i *ifSize="'!S'"
                                   class="fs-9 icon-chevron inline-flex col-43 rotate-90"
                                   aria-hidden="true"></i>
                            </div>
                        </ng-container>
                        <ng-container *ifNotLoggedIn>
                            <div class="height-100 flex flex-justify-center flex-middle"
                                 [gridColumn]="4"
                                 [iCmsModalOpen]="multisiteModalId">
                                <multisite-label [isFooter]="true"></multisite-label>
                                <i class="fs-9 icon-chevron inline-flex col-43 rotate-90"
                                   aria-hidden="true"></i>
                            </div>
                        </ng-container>
                    </ng-container>
                    <ng-container *ifNotTradeStore>
                        <div class="height-100 flex flex-justify-center flex-middle"
                             [gridColumn]="4"
                             [class.pe-none]="hideMultisteRetailSelector"
                             [iCmsModalOpen]="multisiteModalId">
                            <multisite-label [isFooter]="true"></multisite-label>
                            @if (!hideMultisteRetailSelector) {
                            <i class="fs-9 icon-chevron inline-flex col-43 rotate-90"
                               aria-hidden="true"></i>
                            }
                        </div>
                    </ng-container>
                    }
                    }
                </div>
                }
                @for (column of content.columns_mobile; track $index; let index = $index) {
                <page-footer-column-mobile [gridColumn]="12"
                                           [column]="column"
                                           [index]="index">
                </page-footer-column-mobile>
                }
                <ng-container>
                    <div class="p-a-3-m p-a-3-s flex-column flex-justify-center flex-middle b-r"
                         [tradeClass]="'!b-col-42 b-col-43'"
                         [gridColumn]="6">
                        <ng-container *ngTemplateOutlet="call"></ng-container>
                    </div>
                    <div class="p-a-3-m p-a-3-s flex-column flex-justify-center flex-middle"
                         [gridColumn]="6">
                        <ng-container *ngTemplateOutlet="mail"></ng-container>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>
    <div class="b-t"
         [tradeClass]="'!bg-col-w !b-col-42 bg-col-54 b-col-43'">
        <div class="wrap p-t-1 p-b-1 p-t-4-m p-t-4-s p-b-14-m p-b-14-s flex flex-middle flex-column-m flex-column-s">
            <div class="w-3 p-b-3-s w-12 flex-x flex-l flex-middle">
                <div class="pos-relative"
                     *ifSize="'XL'">
                    <multisite-switch></multisite-switch>
                </div>
                <div class="m-l-3-x m-l-3-l center-m center-s p-b-4-s p-b-8-m m-t-1-m m-t-1-s">
                    <ul class="page-footer__payments flex-wrap-s">
                        @for (item of content.payment_method_icons; track $index; let isFirst = $first) {
                        <li class="m-l-2">
                            <img [image]="item.image">
                        </li>
                        }
                    </ul>
                </div>
            </div>
            <div class="w-6-x w-6-l w-12-m w-12-s center m-t-4-m m-t-4-s">
                @if (content.links.length) {
                <ul class="m-t-1-s center">
                    @for (item of content.links; track $index; let isLast = $last) {
                    <li class="inline-block"
                        [ngClass]="{'m-r m-r-2-m m-r-2-s': !isLast}">
                        <href class="p2"
                              [tradeClass]="'!col-11 col-12'"
                              [link]="item.link">
                            <span *iCms="'text' of item; content: 'html'"></span>
                        </href>
                    </li>
                    }
                </ul>
                }
            </div>
            <div class="w-3 w-12-m w-12-s ta-right-x ta-right-l center-m center-s m-t-5-m m-t-5-s">
                <a class="p2 m-r-2 inline-block"
                   [tradeClass]="'!col-11 col-12'"
                   href="https://www.tomandco.co.uk/"
                   target="_blank"
                   title="A London based Magento E-commerce Agency">{{'Made by Tom&Co' | translate}}</a>
            </div>
        </div>
    </div>
</footer>


<ng-template #call>
    <p class="h4"
       [tradeClass]="'!col-11 col-12'">{{'Call us' | translate}}</p>
    <a [attr.href]="'tel:'+content.contact_phone">
        <span class="block m-t-2"
              [tradeClass]="'!col-11 col-w'">
            <i class="icon-call fs-13 fs-14-m fs-14-s"></i>
        </span>
    </a>
    <div class="p1"
         [tradeClass]="'!col-11 col-w'"
         *ifSize="'XL'">
        <a class="block"
           *iCms="'contact_phone' of content"
           [attr.href]="'tel:'+content.contact_phone"></a>
    </div>
</ng-template>

<ng-template #mail>
    <p class="h4"
       [tradeClass]="'!col-11 col-12'">{{'Email us' | translate}}</p>
    <a class="block m-t-2 col-11"
       [attr.href]="'mailto:'+content.contact_mail">
        <i class="icon-contact fs-13 fs-14-m fs-14-s"></i>
    </a>
    <ng-container *ifSize="'XL'">
        <p class="p1"
           [tradeClass]="'!col-11 col-w'"
           *iCms="'contact_mail' of content"></p>
    </ng-container>
</ng-template>

<ng-template #royal>
    @if(content.royalImage) {
    <img [dfImage]="content.royalImage"
         [width]="client.isX ? 260 : 200"
         [ratio]="1"
         [height]="client.isX ? 260 : 200"
         [maxSize]="260">
    }
</ng-template>

}